import type { BlockKind } from "../types";

export const canvasTheme = {
  paper: "#f3f1ec",
  ink: "#1b1f24",
  frame: "rgba(27,31,36,.55)",
  pattern: "rgba(27,31,36,.24)",
  grid: "rgba(27,31,36,.05)",
  gridMajor: "rgba(27,31,36,.09)",
  floor: "#cdc6b8",
  sling: "#2b2f36",
  signal: "#e4572e",
  materials: {
    glass: "#a9d3e6",
    laminated: "#6f9fc4",
    brick: "#b5643c",
    core: "#1f8a5b",
    resonance: "#7d64a8",
    dampener: "#d9a441",
  } satisfies Record<BlockKind, string>,
};
